import React, { useEffect, useState } from "react";
import Layout from "../Common/Layout";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

const QualityComparison = () => {
  const [searchParams] = useSearchParams();
  const crdNo = "CRD-9821"; // 👈 READ FROM QUERY

  console.log(crdNo);

  const [inbound, setInbound] = useState(null);
  const [outbound, setOutbound] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchComparison = async () => {
      const token = sessionStorage.getItem("token");
      if (!token) {
        toast.error("Unauthorized! Please login again.");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `https://irc.zentelex.com/api/quality-qc/compare?crdNo=${encodeURIComponent(
            crdNo
          )}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const result = await response.json();

        if (response.ok) {
          setInbound(result.data.inbound); // ✅ FIXED
          setOutbound(result.data.outbound); // ✅ FIXED
        } else {
          toast.error(result.message || "Failed to fetch comparison data");
        }
      } catch (error) {
        console.error("Comparison Fetch Error:", error);
        toast.error("Server error!");
      } finally {
        setLoading(false);
      }
    };

    fetchComparison();
  }, [crdNo]);

  const renderRow = (label, inboundValue, outboundValue) => {
    const highlight =
      inboundValue !== outboundValue ? { background: "#fff3cd" } : {};

    return (
      <tr style={highlight}>
        <td className="fw-semibold">{label}</td>
        <td>{inboundValue || "-"}</td>
        <td>{outboundValue || "-"}</td>
      </tr>
    );
  };

  if (loading) {
    return (
      <Layout>
        <p className="text-center mt-5">Loading comparison data...</p>
      </Layout>
    );
  }

  if (!inbound || !outbound) {
    return (
      <Layout>
        <p className="text-center mt-5 text-danger">
          No comparison data available for CRD No: <b>{crdNo}</b>
        </p>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="container mt-2">
        <div className="card shadow-sm border-0 rounded-3">
          <div className="card-body p-4">
            <h3 className="text-center mb-3 fw-bold">
              Inbound vs Outbound Quality Comparison
            </h3>

            <p className="text-center text-muted mb-4">
              <strong>CRD No:</strong> {crdNo}
            </p>

            <div className="text-center mb-4">
              <Link
                role="button"
                className="btn btn-primary px-5 py-2 fw-semibold"
                to={`/final-kata-slip?crd_no=${crdNo}`}
              >
                Next Step
              </Link>
            </div>

            <table
              className="table table-bordered table-striped"
              style={{ width: "45rem", marginLeft: "15rem" }}
            >
              <thead className="table-dark">
                <tr>
                  <th>Parameter</th>
                  <th>Inbound</th>
                  <th>Outbound</th>
                </tr>
              </thead>
              <tbody>
                {renderRow("SR No.", inbound.srNo, outbound.srNo)}
                {renderRow(
                  "Sampling Date",
                  inbound.samplingDate,
                  outbound.samplingDate
                )}
                {renderRow(
                  "Analysis Date",
                  inbound.analysisDate,
                  outbound.analysisDate
                )}
                {renderRow(
                  "Client Name",
                  inbound.clientName,
                  outbound.clientName
                )}
                {renderRow(
                  "Commodity",
                  inbound.commodityName,
                  outbound.commodityName
                )}
                {renderRow(
                  "Variety",
                  inbound.varietyName,
                  outbound.varietyName
                )}
                {renderRow("CRD No.", inbound.crdNo, outbound.crdNo)}
                {renderRow("No. of Bags", inbound.noOfBags, outbound.noOfBags)}
                {renderRow(
                  "Quantity (MT)",
                  inbound.quantity,
                  outbound.quantity
                )}
                {renderRow("Odour", inbound.odour, outbound.odour)}
                {renderRow(
                  "Moisture Content",
                  inbound.moistureContent,
                  outbound.moistureContent
                )}
                {renderRow(
                  "Foreign Matter",
                  inbound.foreignMatter,
                  outbound.foreignMatter
                )}
                {renderRow(
                  "Damaged Grains",
                  inbound.damagedGrains,
                  outbound.damagedGrains
                )}
                {renderRow(
                  "Weevilled Grain",
                  inbound.weevilledGrain,
                  outbound.weevilledGrain
                )}
                {renderRow(
                  "Immature Grain",
                  inbound.immatureGrain,
                  outbound.immatureGrain
                )}
                {renderRow(
                  "Broken Grain",
                  inbound.brokenGrain,
                  outbound.brokenGrain
                )}
                {renderRow(
                  "Other Food Grain",
                  inbound.otherFoodGrain,
                  outbound.otherFoodGrain
                )}
                {renderRow(
                  "Live Insect Presence",
                  inbound.liveInsectPresence,
                  outbound.liveInsectPresence
                )}
                {renderRow(
                  "Live Insect Status",
                  inbound.liveInsectStatus,
                  outbound.liveInsectStatus
                )}
                {renderRow(
                  "QA Analyst",
                  inbound.qaAnalystName,
                  outbound.qaAnalystName
                )}
                {renderRow("Remarks", inbound.remarks, outbound.remarks)}
              </tbody>
            </table>

            <p className="text-muted text-center mt-3">
              <strong>Note:</strong> Highlighted rows indicate quality
              differences.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default QualityComparison;
